import styles from './Header.module.css'
import { useGetDashboardQuery } from '../../../../../redux/services/TraderApi'
import formatNumber from '../../../../../utils/functions/formatNumber'
import { Loading } from '../../../../../components/Loading/Loading'

type RateProps = {
  page?: 'withdrawal' | 'orders'
}

export const Rate = ({ page = 'withdrawal' }: RateProps) => {
  const { data, isLoading } = useGetDashboardQuery(undefined, { pollingInterval: 10000 })
  if (isLoading) return <Loading />
  if (!data) return <div className={styles.wrapper} role='alert'>Не удалось загрузить курсы</div>

  const isDeposit = page === 'orders'
  const currencies = data.currencies.filter((currency) =>
    isDeposit ? currency.orders_enabled : currency.withdrawals_enabled
  )

  return (
    <div
      className={`${styles.wrapper} ${styles.currencyRates}`}
      aria-label={isDeposit ? 'Курсы валют пополнений' : 'Курсы валют выплат'}
    >
      <span className={styles.ratesTitle}>{isDeposit ? 'Курсы пополнений' : 'Курсы выплат'}</span>
      {currencies.map((currency) => {
        const rate = isDeposit ? currency.rate : currency.withdrawal_rate
        const percent = isDeposit ? currency.percent : currency.outcome_percent
        return (
          <div className={styles.ratePill} key={currency.code}>
            <span>USDT → {currency.code}</span>
            <strong>{rate === null ? '—' : formatNumber(rate)}</strong>
            <small className={isDeposit ? undefined : styles.withdrawalPercent}>
              {isDeposit ? '+' : '−'}{Number(percent).toFixed(3)}%
            </small>
          </div>
        )
      })}
      {!currencies.length && <span>Нет настроенных курсов</span>}
    </div>
  )
}
